import api from "../http";

/**
 *
 * @param {查询用户列表} data
 * @returns
 */
export function userList_Move(data, gender, loginStatus, birthday, openId) {
  return api.request({
    url: `/frontEnd_user/move_list/${gender}/${loginStatus}/${birthday}/${openId}`,
    method: "get",
    data,
  });
}

/**
 *
 * @param {查询单个用户} data
 * @returns
 */
export function userOne(id) {
  return api.request({
    url: `/frontEnd_user/userInfo/${id}`,
    method: "get",
  });
}

/**
 *
 * @param {修改用户信息} data
 * @returns
 */
export function userUpdate(id, data) {
  return api.request({
    url: `/frontEnd_user/update/${id}`,
    method: "put",
    data,
  });
}
